// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_GKlXg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--_00000033-shadow);
  z-index: 5000;
  outline: none;
}

.subContainer_HOmOS {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 510px; 
  background: var(--f4-background);
  border-radius: 8px;
}

.cancelButton_w9n71 {
  border: 1px solid gray;
  background: var(--white-color);
  height: 40px;
  width: 110px;
  border-radius: 6px;
  border: 1px solid #cbcbcb;
  color: #232222;
  font-weight: 500;
  font-family: Inter;
  cursor: pointer;
}

.containerCustom_gue8S {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--_00000033-shadow);
  z-index: 5000;
}

.content_z_UsM {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px; 
  overflow: hidden;
}

.children_content_KAdlZ {
  padding: 24px 14px;
  width: "100%";
  background-color: var(--white-color);
  border-radius: 8px;
}

.title_Mdmj_ {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  width: 100%;
  padding-left: 16px;
}

.iconTitle_toVqC {
  display: flex;
  align-items: center;
  border-radius: 10px;
}

.gridContainer_cPKyM {
  display: grid;
  gap: 13px;
}

.signInOption_uTvFA {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background-color: var(--white-color);
  width: auto;
  border-radius: 6px;
  height: 34px;
  border: 1px solid #cbcbcbad;
  cursor: pointer;
  font-family: Inter;
  font-weight: 500;
}

.serverConfigContainer_F9kRs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  column-gap: 24px;
}

.dropdownContainer_inBN4 {
  display: flex;
  flex-direction: column;
}



.label_COMFB {
  color: #292a2b;
  font-family: Inter;
  font-weight: 500;
  cursor: pointer;
  margin: 0px;
}

.labelInput_STzBN {
  color: #292a2b;
  font-family: Inter;
  font-weight: 500;
}

.inputContainer_zbo9q {
  display: flex;
  gap: 4px;
  padding: 8px 16px;
  background: var(--f1-background);
  border-radius: 6px;
}

.input_zky6u {
  padding: 0px;
  margin: 0px;
  height: 20px;
  border: none;
  outline: none;
  background-color: transparent;
  color: var(--black-color);
  font-size: 14px;
}

.eye_Bi2wg {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

@keyframes scaleInCenter_jUCiU {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.checkOk_E39rD {
  font-size: 15px;
  color: var(--white-color);
  animation: checkOk_E39rD 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes checkOk_E39rD {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.loader_fjdXA {
  width: 20px;
  height: 20px;
  border: 2px solid var(--white-color);
  border-bottom-color: var(--_10a37f-background);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation_ITSYV 1s linear infinite;
}

@keyframes rotation_ITSYV {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.footer_Vg74e {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  gap: 4px;
  box-sizing: border-box;
  padding: 10px 0px;
  bottom: 15px;
  border-radius: 10px;
  font-size: 12px;
  color: var(--_71717a-color);
  margin-top: 10px;
  margin-bottom: 8px;
  @media (width<=528px) {
    & {
      padding: 30px 10px 22px 10px;
    }
  }
}

.telematelHostPortContainer_HxAiG {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  column-gap: 24px;
}

`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/ModalsAddConnection/ModalAddConnection.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;;AAIA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,uEAAiE;AACnE;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,8CAA8C;EAC9C,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,4CAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB;IACE;MACE,4BAA4B;IAC9B;EACF;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--_00000033-shadow);\n  z-index: 5000;\n  outline: none;\n}\n\n.subContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 510px; \n  background: var(--f4-background);\n  border-radius: 8px;\n}\n\n.cancelButton {\n  border: 1px solid gray;\n  background: var(--white-color);\n  height: 40px;\n  width: 110px;\n  border-radius: 6px;\n  border: 1px solid #cbcbcb;\n  color: #232222;\n  font-weight: 500;\n  font-family: Inter;\n  cursor: pointer;\n}\n\n.containerCustom {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--_00000033-shadow);\n  z-index: 5000;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 480px; \n  overflow: hidden;\n}\n\n.children_content {\n  padding: 24px 14px;\n  width: \"100%\";\n  background-color: var(--white-color);\n  border-radius: 8px;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  width: 100%;\n  padding-left: 16px;\n}\n\n.iconTitle {\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n}\n\n.gridContainer {\n  display: grid;\n  gap: 13px;\n}\n\n.signInOption {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  background-color: var(--white-color);\n  width: auto;\n  border-radius: 6px;\n  height: 34px;\n  border: 1px solid #cbcbcbad;\n  cursor: pointer;\n  font-family: Inter;\n  font-weight: 500;\n}\n\n.serverConfigContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  column-gap: 24px;\n}\n\n.dropdownContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n\n\n.label {\n  color: #292a2b;\n  font-family: Inter;\n  font-weight: 500;\n  cursor: pointer;\n  margin: 0px;\n}\n\n.labelInput {\n  color: #292a2b;\n  font-family: Inter;\n  font-weight: 500;\n}\n\n.inputContainer {\n  display: flex;\n  gap: 4px;\n  padding: 8px 16px;\n  background: var(--f1-background);\n  border-radius: 6px;\n}\n\n.input {\n  padding: 0px;\n  margin: 0px;\n  height: 20px;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  color: var(--black-color);\n  font-size: 14px;\n}\n\n.eye {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n@keyframes scaleInCenter {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.checkOk {\n  font-size: 15px;\n  color: var(--white-color);\n  animation: checkOk 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n}\n\n@keyframes checkOk {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.loader {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--white-color);\n  border-bottom-color: var(--_10a37f-background);\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.footer {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 500px;\n  gap: 4px;\n  box-sizing: border-box;\n  padding: 10px 0px;\n  bottom: 15px;\n  border-radius: 10px;\n  font-size: 12px;\n  color: var(--_71717a-color);\n  margin-top: 10px;\n  margin-bottom: 8px;\n  @media (width<=528px) {\n    & {\n      padding: 30px 10px 22px 10px;\n    }\n  }\n}\n\n.telematelHostPortContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  column-gap: 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_GKlXg`,
	"subContainer": `subContainer_HOmOS`,
	"cancelButton": `cancelButton_w9n71`,
	"containerCustom": `containerCustom_gue8S`,
	"content": `content_z_UsM`,
	"children_content": `children_content_KAdlZ`,
	"title": `title_Mdmj_`,
	"iconTitle": `iconTitle_toVqC`,
	"gridContainer": `gridContainer_cPKyM`,
	"signInOption": `signInOption_uTvFA`,
	"serverConfigContainer": `serverConfigContainer_F9kRs`,
	"dropdownContainer": `dropdownContainer_inBN4`,
	"label": `label_COMFB`,
	"labelInput": `labelInput_STzBN`,
	"inputContainer": `inputContainer_zbo9q`,
	"input": `input_zky6u`,
	"eye": `eye_Bi2wg`,
	"checkOk": `checkOk_E39rD`,
	"loader": `loader_fjdXA`,
	"rotation": `rotation_ITSYV`,
	"footer": `footer_Vg74e`,
	"telematelHostPortContainer": `telematelHostPortContainer_HxAiG`,
	"scaleInCenter": `scaleInCenter_jUCiU`
};
export default ___CSS_LOADER_EXPORT___;
